import React from 'react';
import { Form } from 'react-bootstrap';
import Plaintext from './plaintext';
import Option from './option';
import Helpers from 'utils/helpers';
import InputHelpers from 'components/inputs/utils/inputHelpers';
import useInput from 'hooks/input';
import './select.css';

export default function SelectInputWrapper(props) {
  if (props.plaintext || props.readOnly || props.readonly || props.disabled) {
    let selectedValue = (Helpers.Object.exists(props.value) ? props.value : (Helpers.Object.exists(props.defaultValue) ? props.defaultValue : ''));
    let selectedText = '';
    React.Children.forEach(props.children, (child) => {
      if (child.props.value && child.props.value === selectedValue) {
        selectedText = child.props.label || child.props.children;
      }
    });
    return <Plaintext style={props.style}>{selectedText}</Plaintext>;
  }
  else {
    const clonedProps = { ...props };

    InputHelpers.modifyClonedProps(props, clonedProps);

    return <SelectInput {...clonedProps} />;
  }
}

function SelectInput(props) {
  const { className, onChange, onValueChange, placeholder, feedback, help, description, isInvalid, isValid, alwaysShowValidity, ...childProps } = props;
  const { setInputRef, isInputValid, getInputValidityMessage } = useInput({ description, hasCustomError: (props.isInvalid && feedback), customError: feedback });

  //Begin placeholder fix
  const handleChange = (event) => {
    event.currentTarget.classList.remove('deselected');
    if (onChange) {
      onChange(event);
    }
    if (onValueChange) {
      onValueChange(event.target.value);
    }
  };

  const renderPlaceholder = () => {
    if (placeholder) {
      return (
        <Option className='placeholder' value='' disabled>
          {placeholder}
        </Option>
      );
    }
  };

  const getClass = () => {
    let classNames = [className];
    if (placeholder) {
      if (Helpers.Object.exists(props.value) && Helpers.String.isEmpty(props.value)) {
        classNames.push('deselected');
      }
      else if (Helpers.Object.exists(props.defaultValue) && Helpers.String.isEmpty(props.defaultValue)) {
        classNames.push('deselected');
      }
    }
    return Helpers.String.join(classNames);
  };
  //End placeholder fix

  const renderFeedback = () => {
    if (!isInputValid()) {
      return <div className='invalid-feedback'>{getInputValidityMessage()}</div>;
    }
    else if (props.isInvalid && feedback && !Helpers.String.isEmpty(feedback)) {
      return <div className='invalid-feedback'>{feedback}</div>;
    }
    else if (props.isValid && feedback && !Helpers.String.isEmpty(feedback)) {
      return <div className='valid-feedback'>{feedback}</div>;
    }
    return null;
  };

  const renderHelp = () => {
    if (help && !Helpers.String.isEmpty(help)) {
      return <div className='help-feedback'>{help}</div>;
    }
    return null;
  };

  return (
    <>
      <Form.Control
        {...childProps}
        as='select'
        bsPrefix='custom-select'
        className={getClass()}
        onChange={handleChange}
        ref={setInputRef}
        isInvalid={alwaysShowValidity && isInvalid}
        isValid={alwaysShowValidity && isValid}
      >
        {renderPlaceholder()}
        {props.children}
      </Form.Control>
      {renderHelp()}
      {renderFeedback()}
    </>
  );
}